import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";

/**
 * Modal al portalului (Radix Dialog). Pe mobil urcă de jos (sheet), pe desktop e centrat.
 * Conținutul primește clasa .cp pentru a moșteni tokenii (portalul Radix randează în body).
 */
export function Modal({ open, onOpenChange, title, description, children, footer, size = "md", testid = "modal" }) {
  const w = { sm: "sm:max-w-md", md: "sm:max-w-lg", lg: "sm:max-w-2xl", xl: "sm:max-w-4xl" }[size];
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[100] bg-[#14161A]/45 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0" />
        <DialogPrimitive.Content data-testid={testid}
          className={`cp fixed z-[101] bg-cp-surface shadow-[var(--cp-shadow-lg)] focus:outline-none flex flex-col max-h-[92vh]
            inset-x-0 bottom-0 rounded-t-[14px] border-t border-cp-border
            sm:inset-auto sm:left-1/2 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:w-full ${w} sm:rounded-[var(--cp-radius-lg)] sm:border
            data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-bottom-4 sm:data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0`}>
          <div className="flex items-start justify-between gap-4 px-6 pt-6 pb-4">
            <div className="min-w-0">
              <DialogPrimitive.Title className="cp-h2 !text-[20px]">{title}</DialogPrimitive.Title>
              {description ? <DialogPrimitive.Description className="cp-body-sm mt-1">{description}</DialogPrimitive.Description>
                : <DialogPrimitive.Description className="sr-only">{title}</DialogPrimitive.Description>}
            </div>
            <DialogPrimitive.Close aria-label="Închide" data-testid={`${testid}-close`}
              className="h-9 w-9 -mr-2 -mt-1 grid place-items-center rounded-[var(--cp-radius)] text-cp-text-3 hover:text-cp-text hover:bg-cp-surface-active transition-colors shrink-0">
              <X className="h-4 w-4" />
            </DialogPrimitive.Close>
          </div>
          <div className="px-6 pb-2 overflow-y-auto">{children}</div>
          {footer && <div className="px-6 py-4 mt-2 border-t border-cp-border flex flex-col-reverse sm:flex-row sm:justify-end gap-2 bg-cp-bg/60 rounded-b-[var(--cp-radius-lg)]">{footer}</div>}
          {!footer && <div className="pb-4" />}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}

/** Lightbox pentru fotografii — fundal închis, fără chrome. */
export function Lightbox({ open, onOpenChange, children, label = "Fotografie" }) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[100] bg-[#14161A]/90 data-[state=open]:animate-in data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content aria-describedby={undefined}
          className="cp fixed z-[101] inset-0 sm:inset-6 lg:inset-10 focus:outline-none flex items-center justify-center data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95">
          <DialogPrimitive.Title className="sr-only">{label}</DialogPrimitive.Title>
          <DialogPrimitive.Close aria-label="Închide" data-testid="lightbox-close"
            className="absolute top-3 right-3 sm:top-0 sm:right-0 h-10 w-10 grid place-items-center rounded-full bg-black/40 text-white hover:bg-black/60 transition-colors z-10">
            <X className="h-5 w-5" />
          </DialogPrimitive.Close>
          {children}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
